/**
 * Animation easing equations - linear
 *
 * @param pos - a number from 0.0-1.0 representing the fraction of completion
 */
export function easingLinear(pos: number): number {
  return pos;
}
